var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { selectIsHudVisible } from "../../selectors/selectIsHudVisible";
export var HOCHudComponent = function (HudComponent) {
    var HUDComponent = /** @class */ (function (_super) {
        __extends(HUDComponent, _super);
        function HUDComponent() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        HUDComponent.prototype.render = function () {
            if (!this.props.shouldRender) {
                return React.createElement(React.Fragment, null);
            }
            return React.createElement(HudComponent, __assign({}, this.props, this.state));
        };
        return HUDComponent;
    }(React.Component));
    var mapState = function (state) { return ({
        shouldRender: selectIsHudVisible(state),
    }); };
    return connect(mapState)(HUDComponent);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/context-menu/HOCHudComponent.tsx
// module id = 225
// module chunks = 3